import useCurrentUser from "@v2/hooks/useCurrentUser";
import { useLocalStorageState } from "@v2/hooks/useLocalStorage";
import { z } from "zod";

/**
 * @returns Either the last visited workspace id (as saved in localStorage) or
 * the first workspace that the user has access to (as determined by the backend)
 *
 * @deprecated TODO (Noah, 2025-02-22): This really shouldn't be necessary - it's only used
 * on the account settings and dashboard /home pages, and in those cases we shouldn't
 * actually show any workspace details at all. Almost always, you want useCurrentWorkspaceId
 * instead. The design of the app should be updated to not need this.
 */
export const useDefaultWorkspaceId = () => {
  const [lastVisitedWorkspaceId] = useLocalStorageState(
    "replo.workspace.lastvisitedWorkspaceId",
    null,
    { schema: z.uuid().nullish() },
  );

  const { user, isLoading: isLoadingUser } = useCurrentUser();

  if (lastVisitedWorkspaceId) {
    return lastVisitedWorkspaceId;
  }

  if (isLoadingUser) {
    return null;
  }

  return user?.workspace?.id;
};
